import React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import ModelOutput from './ModelOutput';

const DraggableModelOutput = ({
    model,
    title,       // 新增title属性，从父组件(App.js)传入的展示名称
    output,
    index,
    onClose,
    onRegenerate,
    onClear,
    moveModel,
    icon,
}) => {
    const ref = React.useRef(null);

    const [, drop] = useDrop({
        accept: 'MODEL_OUTPUT',
        hover(item) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;

            if (dragIndex === hoverIndex) {
                return;
            }

            moveModel(dragIndex, hoverIndex); // 调用父组件的方法实现位置交换
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: 'MODEL_OUTPUT',
        item: { index },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    drag(drop(ref));

    return (
        <div
            ref={ref}
            style={{
                opacity: isDragging ? 0.5 : 1,
                cursor: 'move',
            }}
        >
            <ModelOutput
                model={model}
                title={title}   // 将title传递给ModelOutput，这里使用title作为展示名称
                output={output}
                icon={icon}
                onClose={onClose}
                onRegenerate={onRegenerate}
                onClear={onClear}
            />
        </div>
    );
};

export default DraggableModelOutput;

